// extracted by mini-css-extract-plugin
export default {"label":"FormInput_label__XaBb6"};